export default __webpack_public_path__ + "vienna-253d4502bf20debce22b339cfc704dc4.bundle.jpg";